export default "__VITE_ASSET__7NvuH$M3__"